import React, {useEffect} from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { sumBy } from "lodash"
import { numberToCurrency } from "helpers/string"

import { CATEGORY_ICONS } from "constants/accounting"
import { Icon } from "ui/Icon"
import FormAntdModal from "./FormAntdModal"
import { useSelector, useDispatch } from "react-redux"
import { getExpense } from "store/accounting"
// import FormAntdModal from "features/expenses/components/FormAntdModal"

DayDetails.propTypes = {
  date: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      class_name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      displayed_name: PropTypes.string.isRequired,
      displayed_for: PropTypes.string,
      stripe: PropTypes.bool,
      slug: PropTypes.string
    })
  ).isRequired
}

LinkWrapperToEditExpence.propTypes = {
  record: PropTypes.shape({
    class_name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string
}

function LinkWrapperToEditExpence({ record, children, className, color = "primary-second" }) {
  const expense = useSelector((store) => store?.accounting?.expense)
  const dispatch = useDispatch();
  const [showModal, setShowModal] = React.useState(false);
  const prevIdRef = React.useRef();

  useEffect(() => {
    if (showModal && record?.id && prevIdRef.current !== record.id) {
      dispatch(getExpense(record.id));
      prevIdRef.current = record.id;
    }
    if (!showModal) {
      prevIdRef.current = undefined;
    }
  }, [showModal, record?.id, dispatch]);
  if (record.class_name === "Expense") {
    return (
      <>
        <button
          type="button"
          className={["text-dark text-decoration-none bg-opacity-0 bg-opacity-5-hover border-0 bg-transparent p-0", `bg-${color}`, className].join(" ")}
          style={{ cursor: "pointer" }}
          onClick={() => setShowModal(true)}
        >
          {children}
        </button>
        {showModal && record?.id && (
          <FormAntdModal expenseId={record?.id} expense={expense} record={record} visible={showModal} setVisible={setShowModal} />
        )}
      </>
    );
  }
  return <div className={className}>{children}</div>;
}

const getCategoryIcon = (slug) => {
  const icon = CATEGORY_ICONS[slug]
  return icon ?? "profit"
}

export default function DayDetails({ date, items = [] }) {
  const today = moment().startOf("day")
  const isToday = moment(date).diff(today, "days") === 0
  const dayLongFormat = isToday ? "[Today]" : "DD MMM"
  const headFormat = dayLongFormat

  const totalAmount = sumBy(items, "amount")

  return (
    <div className="bg-white rounded overflow-hidden">
      <div className="hstack justify-content-between gap-10 px-15 py-10 border-bottom border-gray-lightest">
        {date && (
          <p className={["fs-6 fw-medium m-0", isToday ? "text-primary-second" : ""].join(" ")}>{moment(date).format(headFormat)}</p>
        )}
        <p className="fs-6 fw-medium m-0">{numberToCurrency(totalAmount)}</p>
      </div>
      {items.length > 0 && (
        <div className="vstack">
          {items.map((record, index) => {
            const color = record.stripe ? "stripe" : "success"
            return (
              <LinkWrapperToEditExpence record={record} key={record.id} className="hstack gap-2 align-items-center fs-7 py-10 px-15">
                <div
                  className={[
                    "rounded-circle p-2 bg-surface-1",
                    record.class_name === "Income"
                      ? record.amount >= 0
                        ? "bg-primary text-primary"
                        : "bg-danger text-danger"
                      : "text-primary-second"
                  ].join(" ")}
                >
                  <Icon name={getCategoryIcon(record.slug)} />
                </div>
                <div>
                  <div className="fst-italic">{record.displayed_name}</div>
                  <div className="small text-dark text-opacity-50">{record.displayed_for}</div>
                </div>
                <div
                  className={`d-inline-block py-0 px-2 rounded fs-7 fw-semibold lh-base text-${color} bg-${color} bg-opacity-25 text-center ms-auto me-2`}
                >
                  {record.stripe ? "Card" : "Cash"}
                </div>
                <div className={record.amount < 0 ? "text-danger" : ""}>{numberToCurrency(record.amount)}</div>
              </LinkWrapperToEditExpence>
            )
          })}
        </div>
      )}
    </div>
  )
}
